import { Component, OnInit, ElementRef, ViewChild, HostBinding, Renderer2, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { CommonService } from '../services/common.service';
import { HomeDataService } from '../services/home-data.service';
import { Modal } from 'bootstrap';
import * as Highcharts from 'highcharts';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { ConfigService } from '../services/auth/config.service';
import { Tooltip } from 'bootstrap';
declare var bootstrap: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-100px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-100px)' })),
      ]),
    ]),
  ]
})
export class HomeComponent implements OnInit, AfterViewInit {
  currentMonth: number = new Date().getMonth();
  currentYear: number = new Date().getFullYear();
  daysInMonth: any[] = [];
  columns: any[] = [];
  isAuthenticated: boolean = false;
  modalHeader = '';

  visibleNotifications: any[] = [];
  showAll = false;
  limit = 5;
  // Month names for display
  monthNames: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];


  // Holiday List
  // holidays: { date: string; name: string }[] = [
  //   { date: '2025-01-01', name: "🎉 New Year's Day" },
  //   { date: '2025-04-01', name: 'April Fools Day' },
  //   { date: '2025-08-15', name: 'Independence Day' },
  //   { date: '2025-12-25', name: '🎄 Christmas' }
  // ];
  holidays: { date: string; name: string }[] = [];
  rows: any = []
  rows1998 = [
    {
      circle: "Assistant Registrar (Bilaspur)",
      applications_received: 46,
      pending_admission: 0,
      under_process: 7,
      returned: 7,
      rejected: 3,
      e_certificates_issued: 29
    },
    {
      circle: "Assistant Registrar (Chamba)",
      applications_received: 56,
      pending_admission: 1,
      under_process: 1,
      returned: 14,
      rejected: 5,
      e_certificates_issued: 35
    },
    {
      circle: "Assistant Registrar (Dehra)",
      applications_received: 19,
      pending_admission: 0,
      under_process: 0,
      returned: 6,
      rejected: 1,
      e_certificates_issued: 12
    },
    {
      circle: "Assistant Registrar (Dharamshala)",
      applications_received: 38,
      pending_admission: 0,
      under_process: 0,
      returned: 6,
      rejected: 2,
      e_certificates_issued: 30
    },
    {
      circle: "Assistant Registrar (Hamirpur)",
      applications_received: 61,
      pending_admission: 0,
      under_process: 0,
      returned: 7,
      rejected: 17,
      e_certificates_issued: 37
    },
    {
      circle: "Assistant Registrar (Jubbal)",
      applications_received: 53,
      pending_admission: 5,
      under_process: 2,
      returned: 10,
      rejected: 7,
      e_certificates_issued: 29
    },
    {
      circle: "Assistant Registrar (Kinnaur)",
      applications_received: 3,
      pending_admission: 0,
      under_process: 0,
      returned: 1,
      rejected: 0,
      e_certificates_issued: 2
    },
    {
      circle: "Assistant Registrar (Kullu)",
      applications_received: 248,
      pending_admission: 1,
      under_process: 29,
      returned: 28,
      rejected: 24,
      e_certificates_issued: 166
    },
    {
      circle: "Assistant Registrar (L&S)",
      applications_received: 3,
      pending_admission: 0,
      under_process: 0,
      returned: 0,
      rejected: 0,
      e_certificates_issued: 3
    },
    {
      circle: "Assistant Registrar (Mandi)",
      applications_received: 435,
      pending_admission: 1,
      under_process: 30,
      returned: 102,
      rejected: 34,
      e_certificates_issued: 268
    },
    {
      circle: "Assistant Registrar (Nurpur)",
      applications_received: 35,
      pending_admission: 0,
      under_process: 3,
      returned: 5,
      rejected: 11,
      e_certificates_issued: 16
    },
    {
      circle: "Assistant Registrar (Palampur)",
      applications_received: 136,
      pending_admission: 0,
      under_process: 1,
      returned: 12,
      rejected: 1,
      e_certificates_issued: 122
    },
    {
      circle: "Assistant Registrar (Shimla)",
      applications_received: 133,
      pending_admission: 0,
      under_process: 16,
      returned: 41,
      rejected: 12,
      e_certificates_issued: 64
    },
    {
      circle: "Assistant Registrar (Sirmour)",
      applications_received: 58,
      pending_admission: 0,
      under_process: 0,
      returned: 18,
      rejected: 8,
      e_certificates_issued: 32
    },
    {
      circle: "Assistant Registrar (Solan)",
      applications_received: 70,
      pending_admission: 0,
      under_process: 2,
      returned: 24,
      rejected: 10,
      e_certificates_issued: 34
    },
    {
      circle: "Assistant Registrar (Una)",
      applications_received: 40,
      pending_admission: 1,
      under_process: 2,
      returned: 11,
      rejected: 0,
      e_certificates_issued: 26
    }
  ];
  rows2006 = [
    {
      "sr_no": 1,
      "registration_office": "Directorate of Cooperation, SHIMLA",
      "applications_received": 803,
      "pending_admission": 15,
      "under_process": 3,
      "returned": 342,
      "rejected": 0,
      "e_certificates_issued": 440
    },
    {
      "sr_no": 2,
      "registration_office": "DC Office, SHIMLA",
      "applications_received": 91,
      "pending_admission": 3,
      "under_process": 1,
      "returned": 46,
      "rejected": 0,
      "e_certificates_issued": 41
    },
    {
      "sr_no": 3,
      "registration_office": "DC Office, SOLAN",
      "applications_received": 133,
      "pending_admission": 0,
      "under_process": 3,
      "returned": 55,
      "rejected": 1,
      "e_certificates_issued": 74
    },
    {
      "sr_no": 4,
      "registration_office": "DC Office, NAHAN",
      "applications_received": 95,
      "pending_admission": 3,
      "under_process": 5,
      "returned": 27,
      "rejected": 3,
      "e_certificates_issued": 59
    },
    {
      "sr_no": 5,
      "registration_office": "DC Office, MANDI",
      "applications_received": 102,
      "pending_admission": 1,
      "under_process": 0,
      "returned": 53,
      "rejected": 0,
      "e_certificates_issued": 48
    },
    {
      "sr_no": 6,
      "registration_office": "DC Office, BILASPUR",
      "applications_received": 56,
      "pending_admission": 0,
      "under_process": 2,
      "returned": 20,
      "rejected": 1,
      "e_certificates_issued": 34
    },
    {
      "sr_no": 7,
      "registration_office": "DC Office, UNA",
      "applications_received": 115,
      "pending_admission": 0,
      "under_process": 3,
      "returned": 30,
      "rejected": 2,
      "e_certificates_issued": 82
    },
    {
      "sr_no": 8,
      "registration_office": "DC Office, HAMIRPUR",
      "applications_received": 67,
      "pending_admission": 1,
      "under_process": 0,
      "returned": 34,
      "rejected": 0,
      "e_certificates_issued": 32
    },
    {
      "sr_no": 9,
      "registration_office": "DC Office, CHAMBA",
      "applications_received": 82,
      "pending_admission": 1,
      "under_process": 7,
      "returned": 24,
      "rejected": 7,
      "e_certificates_issued": 48
    },
    {
      "sr_no": 10,
      "registration_office": "DC Office, KULLU",
      "applications_received": 146,
      "pending_admission": 4,
      "under_process": 4,
      "returned": 32,
      "rejected": 1,
      "e_certificates_issued": 106
    },
    {
      "sr_no": 11,
      "registration_office": "DC Office, DHARMSHALA",
      "applications_received": 151,
      "pending_admission": 20,
      "under_process": 3,
      "returned": 57,
      "rejected": 1,
      "e_certificates_issued": 64
    },
    {
      "sr_no": 12,
      "registration_office": "DC Office, RECONG-PEO",
      "applications_received": 56,
      "pending_admission": 0,
      "under_process": 3,
      "returned": 5,
      "rejected": 0,
      "e_certificates_issued": 48
    },
    {
      "sr_no": 13,
      "registration_office": "DC Office, LAHUL AND SPITI",
      "applications_received": 30,
      "pending_admission": 1,
      "under_process": 3,
      "returned": 11,
      "rejected": 2,
      "e_certificates_issued": 15
    }
  ]

  constructor(private configService:ConfigService, private homeDataService:HomeDataService, private authService: AuthService, private commonService: CommonService, private router: Router, private renderer: Renderer2) {
    // localStorage.clear();

    //  this.authService.logout();

    // this.getEvents(3,0,0,0);

  }

  @ViewChild('slidesContainer') slidesContainer!: ElementRef;
  @ViewChildren('indicator', { read: ElementRef }) indicatorRefs!: QueryList<ElementRef>;
  @ViewChild('progressBar') progressBar!: ElementRef;

  slides: HTMLElement[] = [];
  indicators: HTMLElement[] = [];
  currentSlide = 0;
  slideDuration = 5000;
  slideInterval: any;

  @ViewChild('chartSection') chartSection!: ElementRef;
  ChartOptions: any = {}
  societyNgo:any
societyStats = [
  {
    title: 'Transport Cooperative',
    count: 4174,
    icon: 'bi bi-truck'
  },
  {
    title: 'Tribal SC/ST Cooperatives',
    count: 1516,
    icon: 'bi bi-people'
  },
  {
    title: 'Urban Co-operative Banks',
    count: 1345,
    icon: 'bi bi-bank'
  },
  {
    title: "Women's Welfare Cooperative",
    count: 25067,
    icon: 'bi bi-gender-female'
  },
  {
    title: 'Agriculture & Allied',
    count: 27143,
    icon: 'bi bi-tree'
  }
];
  applicationData = [
    {
      "circle": "Assistant Registrar (Bilaspur)",
      "applications_received": 46,
      "pending_admission": 0,
      "under_process": 7,
      "returned": 7,
      "rejected": 3,
      "e_certificates_issued": 29
    },
    {
      "circle": "Assistant Registrar (Chamba)",
      "applications_received": 56,
      "pending_admission": 1,
      "under_process": 1,
      "returned": 14,
      "rejected": 5,
      "e_certificates_issued": 35
    },
    {
      "circle": "Assistant Registrar (Dehra)",
      "applications_received": 19,
      "pending_admission": 0,
      "under_process": 0,
      "returned": 6,
      "rejected": 1,
      "e_certificates_issued": 12
    },
    {
      "circle": "Assistant Registrar (Dharamshala)",
      "applications_received": 38,
      "pending_admission": 0,
      "under_process": 0,
      "returned": 6,
      "rejected": 2,
      "e_certificates_issued": 30
    },
    {
      "circle": "Assistant Registrar (Hamirpur)",
      "applications_received": 61,
      "pending_admission": 0,
      "under_process": 0,
      "returned": 7,
      "rejected": 17,
      "e_certificates_issued": 37
    },
    {
      "circle": "Assistant Registrar (Jubbal)",
      "applications_received": 53,
      "pending_admission": 5,
      "under_process": 2,
      "returned": 10,
      "rejected": 7,
      "e_certificates_issued": 29
    },
    {
      "circle": "Assistant Registrar (Kinnaur)",
      "applications_received": 3,
      "pending_admission": 0,
      "under_process": 0,
      "returned": 1,
      "rejected": 0,
      "e_certificates_issued": 2
    },
    {
      "circle": "Assistant Registrar (Kullu)",
      "applications_received": 248,
      "pending_admission": 1,
      "under_process": 29,
      "returned": 28,
      "rejected": 24,
      "e_certificates_issued": 166
    },
    {
      "circle": "Assistant Registrar (L&S)",
      "applications_received": 3,
      "pending_admission": 0,
      "under_process": 0,
      "returned": 0,
      "rejected": 0,
      "e_certificates_issued": 3
    },
    {
      "circle": "Assistant Registrar (Mandi)",
      "applications_received": 435,
      "pending_admission": 1,
      "under_process": 30,
      "returned": 102,
      "rejected": 34,
      "e_certificates_issued": 268
    },
    {
      "circle": "Assistant Registrar (Nurpur)",
      "applications_received": 35,
      "pending_admission": 0,
      "under_process": 3,
      "returned": 5,
      "rejected": 11,
      "e_certificates_issued": 16
    },
    {
      "circle": "Assistant Registrar (Palampur)",
      "applications_received": 136,
      "pending_admission": 0,
      "under_process": 1,
      "returned": 12,
      "rejected": 1,
      "e_certificates_issued": 122
    },
    {
      "circle": "Assistant Registrar (Shimla)",
      "applications_received": 133,
      "pending_admission": 0,
      "under_process": 16,
      "returned": 41,
      "rejected": 12,
      "e_certificates_issued": 64
    },
    {
      "circle": "Assistant Registrar (Sirmour)",
      "applications_received": 58,
      "pending_admission": 0,
      "under_process": 0,
      "returned": 18,
      "rejected": 8,
      "e_certificates_issued": 32
    },
    {
      "circle": "Assistant Registrar (Solan)",
      "applications_received": 70,
      "pending_admission": 0,
      "under_process": 2,
      "returned": 24,
      "rejected": 10,
      "e_certificates_issued": 34
    },
    {
      "circle": "Assistant Registrar (Una)",
      "applications_received": 40,
      "pending_admission": 1,
      "under_process": 2,
      "returned": 11,
      "rejected": 0,
      "e_certificates_issued": 26
    }
  ]
  seriesDataNew: any = []
  showChart = false;
  showModal = false;
  Highcharts: typeof Highcharts = Highcharts;
  // columns = [
  //   { prop: 'circle', name: 'Circle' },
  //   { prop: 'applications_received', name: 'Applications Received' },
  //   { prop: 'pending_admission', name: 'Pending Admission' },
  //   { prop: 'under_process', name: 'Under Process' },
  //   { prop: 'returned', name: 'Returned' },
  //   { prop: 'rejected', name: 'Rejected' },
  //   { prop: 'e_certificates_issued', name: 'E-Certificates Issued' },
  // ];

  ngOnInit() {

    // let Received:any={name:'Online Application Recieved',data:[],  type: 'bar'}
    // this.applicationData.forEach((i)=>{ 

    //   this.categories.push(i.circle); 
    //   Received?.data.push(i.applications_received); 
    // })
    // this.seriesDataNew.push(Received) 
    // this.seriesData = this.seriesDataNew   

    // this.ChartOptions.title = "Online Application Submitted Under Act 1968"
    // this.ChartOptions.subtitle = `Total Application Recieved`
    // this.ChartOptions.categories = this.categories
    // this.ChartOptions.seriesData = this.seriesData
this.getNotification()
this.getState();
    this.isAuthenticated = this.authService.isAuthenticated();
    this.generateCalendar(this.currentYear, this.currentMonth);
    // localStorage.clear();
    // this.authService.logout();
    this.getEvents(3, 0, 0, 0);

    if (this.isAuthenticated) {
      this.router.navigate(['/dashboard']);
    }

  }

  getNotification(){
    this.notifications=[]
    this.homeDataService.getNotifications().subscribe({
      next: (response) => {
  
        if (response.status === 200) {
          // this.rows = response.data;
       
          this.notifications = [...response.data];

    this.visibleNotifications = this.notifications.slice(0, this.limit);
       
        } else {
         // this.toastService.showError(response?.message)
        }
      },
      error: (error) => {
     
      },
    });
  }

   getState(){
    this.notifications=[]
    this.homeDataService.getDashboardStats().subscribe({
      next: (response) => {
      
  
        if (response.status === 200) {
   
        this.societyStats=response.data.cooperative
        this.societyNgo =response.data.ngo
       
        } else {
         // this.toastService.showError(response?.message)
        }
      },
      error: (error) => {
     
      },
    });
  }

    downloadFile(fileName: string) {
    const fileUrl = this.configService.getFileUrl() + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }
  cards = [
    {
      title: 'Registration of NGO/Welfare Society (Act 2006)',
      description: `The Himachal Pradesh Societies Registration Act, 2006 is an Act to provide for the registration and working of literary, scientific, educational, religious, charitable or other Societies in the State of Himachal Pradesh.`,

      links: {
        act: '../../assets/society-sample/Act_2006.pdf',


        apply: '/societyRegistration'

      },

      timeLimit: {
        normal: '21 days',
        objection: '15 days'
      },

      lastUpdated: '05-05-2026 11:26 AM',

      stats: {
        submitted: 16895,
        approved: 12580,
        rejected: null,
        certificates: 12580,
        feeVerified: 12580,
        avgFee: 393
      },

      time: {
        avg: '93 day(s) 23.3 hr(s)',
        median: '36 day(s) 9.1 hr(s)',
        min: '0.6 hr(s)',
        max: '1571 day(s) 23.4 hr(s)'
      }
    },
    {
      title: 'Registration of Cooperative Society (Act 1968)',
      description: `The Himachal Pradesh Co-operative Societies Act, 1968 is an Act to register, consolidate and amend the law relating to Co-operative societies in the State of Himachal Pradesh.`,

      links: {
        act: '../../assets/society-sample/Act_1968.pdf',


        apply: '/societyRegistration'
      },

      timeLimit: {
        normal: '21 days',
        objection: '15 days'
      },

      lastUpdated: '05-05-2026 11:26 AM',

      stats: {
        submitted: 2027,
        approved: 1383,
        rejected: 199,
        certificates: 1383,
        feeVerified: null,
        avgFee: null
      },

      time: {
        avg: '31 day(s) 0.6 hr(s)',
        median: '27 day(s) 2.2 hr(s)',
        min: '0.2 hr(s)',
        max: '343 day(s) 23.0 hr(s)'
      }
    }
  ];
  currentIndex = 0;

  messages = [
    {
      image: 'assets/images/avatar/6.jpg',
      name: 'Mr. Mukesh Agnihotri',
      designation: "Hon'ble Cooperation Minister",
      text: `The Co-operative Societies are the fundamental units of
                democracy and self reliance. The stage of Cooperative
                movement in a State thus, reflects the level of democratic
                ideals in political governance. Himachal Pradesh has
                pioneered in Co-operative movement in 1904 and now with
                5038 Societies it reflects the public sentiment in self
                governance over the years. The Department of Cooperation
                has come out with a dedicated and interactive web-site for
                the use of public as well as other Govt. departments. My
                best wishes to the Department of Cooperation and the
                Cooperatives of the State.`
    },
    {
      image: 'assets/images/avatar/7.jpeg',
      name: 'Sh. Amarjeet singh',
      designation: 'IAS (Secretary Cooperation)',
      text: `  The Department of Cooperation ever since its inception has
                shown great responsibility towards public service. From
                the level of preliminary non-credit Primary Cooperative
                Societies, the Cooperative movement in the State has
                developed into multifaceted structure of credit
                institutions viz Cooperative Banks and Federations. With
                the launch of the dedicated and function specific
                web-site, the Department of Cooperation has made another
                endeavor to reach to the public and provide them platform
                for general information of the department. The site will
                provide the maximum information which the public would
                like to know about the department and the Co-operative
                Societies.`
    },
    {
      image: 'assets/images/avatar/8.jpeg',
      name: 'Sh. DC Negi',
      designation: 'Registrar Cooperative Societies',
      text: `           Welcome to the website of the Department of Cooperation
                H.P. The Department of Cooperation plays an important role
                to eliminate exploitation of common man by middleman and
                money leaders by ensuring credit facilities to farmers at
                low rate of interest through cooperatives, focus being to
                ameliorate socio-economic condition of the people.
                Himachal Pradesh has pioneered in cooperative movement in
                1904 and now 5038 cooperatives of various kinds are
                functioning in the State. These cooperatives are providing
                multi farious services to the people of the State which
                includes distribution of consumer goods under PDS,
                Distribution of fertilizers and other agricultural related
                inputs and implements, collection of milk and its
                marketing through mild cooperatives and Milk Fed,
                advancement of S.T., M.T loans through PACS and other
                cooperative financial institutions, marketing of
                agricultural and horticultural produces, production of
                hand-loom and handicraft products, fisheries,
                transportation services through transport cooperatives
                etc. I am glad to bring it to the notice of general public
                that the Department has started online registration of the
                societies under the provision of H.P. Societies
                Registration Act, 2006.`
    }
  ];


  next() {
    this.currentIndex = (this.currentIndex + 1) % this.messages.length;
  }

  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.messages.length) % this.messages.length;
  }

  // toggleView() {
  //   this.showAll = !this.showAll;

  //   this.visibleNotifications = this.showAll
  //     ? this.notifications
  //     : this.notifications.slice(0, this.limit);
  // }
  toggleView() {
    this.router.navigate(['/notifications']);
  }
  notifications = [
    {
      date: '28/04/2026',
      title: 'Office Order regarding amendments in HP Cooperative Societies Rules 1971 relating to terms of Employment and working conditions of the Employees of PACS 2001.',
      link: '#',
      isNew: true
    },
    {
      date: '16/04/2026',
      title: 'Office Order regarding conduct the audit of eligible classes of PACS',
      link: '#'
    },
    {
      date: '04/04/2026',
      title: 'Notification regarding integration with HIMPROCESS',
      link: '#'
    },
    {
      date: '31/03/2026',
      title: 'Office order regarding nomination of Nodal Officer to registered Primary Cooperative Societies employees on iGOT e-learning platform.',
      link: '#'
    }
  ];
  generateCalendar(year: number, month: number) {
    this.daysInMonth = [];
    let firstDay = new Date(year, month, 1).getDay(); // Get first day (0=Sunday, 6=Saturday)
    const totalDays = new Date(year, month + 1, 0).getDate(); // Get total days in the month

    // Fill empty slots before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      this.daysInMonth.push(null);
    }

    // Fill actual days of the month
    for (let day = 1; day <= totalDays; day++) {
      const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const holiday = this.holidays.find(h => h.date === dateStr);

      const currentDate = new Date(year, month, day);
 

      this.daysInMonth.push({ day, holiday, isSunday: currentDate.getDay() === 0 });
    }
  }
  selectedHoliday: any = null;
  hasHoliday: boolean = false;
  openHolidayModal(holiday: any) {
    if (holiday) {
      this.selectedHoliday = holiday;
      this.hasHoliday = true;
    } else {
      this.selectedHoliday = null;
      this.hasHoliday = false;
      return;
    }
    const modalEl = document.getElementById('holidayModal');
    if (modalEl) {
      const modal = new Modal(modalEl);
      modal.show();
    } else {
      console.error('Modal element not found!');
    }
  }
  // Function to change the month
  changeMonth(step: number) {
    this.currentMonth += step;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    } else if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar(this.currentYear, this.currentMonth);
  }

  ngAfterViewInit(): void {
    this.slides = Array.from(this.slidesContainer.nativeElement.querySelectorAll('.slide'));
    this.indicators = Array.from(document.querySelectorAll('.indicator'));
    this.startSlider();

    const carouselElement = document.getElementById('adminMessageCarousel');
    if (carouselElement) {
      new bootstrap.Carousel(carouselElement, {
        interval: 5000,
        ride: 'carousel'
      });
    }
  }


  eventList: any[] = [];
  getEvents(flag: number, Id: number, pageSize: number, pageNumber: number) {
    this.commonService.getEvents(flag, Id, pageSize, pageNumber).subscribe((response) => {
      if (response.status === 200) {
        this.eventList = response.data;
 
        this.holidays = response.data;
         this.initializeTooltips();
        this.generateCalendar(this.currentYear, this.currentMonth);
      }
      else {
      }
    },
      (error) => {
        console.error("Error fetching data", error);
      });
  }
  initializeTooltips(): void {
    setTimeout(() => {
      const tooltipElements = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipElements.forEach(el => new Tooltip(el));
    });
  }

  openModal(model: any, year: any) {
    if (year === '1968') {
      this.rows = []
      this.rows = this.rows1998;
      this.modalHeader = "Online Applications Submitted under Act 1968";
      this.columns = [
        // { name: '#', prop: 'id', sortable: false, maxWidth: 40 },
        { name: 'Circle', prop: 'circle', sortable: true },
        { name: 'Applications Received', prop: 'applications_received', sortable: true }
      ];

    }
    else {
      this.rows = []
      this.modalHeader = "Online Applications Submitted under Act 2006";
      this.rows = this.rows2006;

      this.columns = [
        // { name: '#', prop: 'id', sortable: false, maxWidth: 40 },
        { name: 'Registration Office', prop: 'registration_office', sortable: true },
        { name: 'Applications Received', prop: 'applications_received', sortable: true }
      ];
    }
    this.updateChartData(year)
    this.showModal = true;
    this.showChart = false;
    // const modalElement = document.getElementById(model);
    // if (modalElement) {
    //   const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
    //   modalInstance.show();

    // }
  }

  closeModel() {
    this.rows = [];
    this.columns = []
    this.showModal = false;
    this.showChart = false;
  }
  toggleModal() {
    this.showModal = !this.showModal;
    this.showChart = false;
    // this.ChartOptions = {}
  }
  toggleChart() {
    this.showChart = !this.showChart;

    if (this.showChart) {
      // Wait a tick for the chart to render, then scroll
      setTimeout(() => {
        this.chartSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

  updateChartData(year: any) {
    const categories: string[] = [];
    const receivedData: number[] = [];
    let totalReceived = 0
    this.rows.forEach((entry: any) => {

      if (year === '1968') {
        categories.push(entry.circle);
      } if (year === '2006') {
        categories.push(entry.registration_office);
      }

      receivedData.push(entry.applications_received);
      totalReceived += entry.applications_received
    });

    this.ChartOptions = {
      title: this.modalHeader,
      subtitle: `Total Application Recieved : ${totalReceived}`,
      categories,
      yAxisTitle: 'Number of Applications',
      seriesData: [{
        name: 'Online Application Recieved',
        data: receivedData,
        type: 'bar'
      }]
    };

  }

  barChartOptions: Highcharts.Options = {
    chart: {
      type: 'bar'
    },
    title: {
      text: 'Online Application '
    },
    subtitle: {
      text: 'Source: <a href="https://en.wikipedia.org/wiki/List_of_continents_and_continental_subregions_by_population" target="_blank">Wikipedia.org</a>'
    },
    xAxis: {
      categories: ['Africa', 'America', 'Asia', 'Europe'],
      title: { text: null },
      gridLineWidth: 1,
      lineWidth: 0
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Population (millions)',
        align: 'high'
      },
      labels: {
        overflow: 'justify'
      },
      gridLineWidth: 0
    },
    tooltip: {
      valueSuffix: ' millions'
    },
    plotOptions: {
      bar: {
        borderRadius: '50%',
        dataLabels: { enabled: true },
        groupPadding: 0.1
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top',
      x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      backgroundColor: '#ffffff',
      shadow: true
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: 'Year 1990',
        type: 'bar',
        data: [632, 727, 3202, 721]
      },
      {
        name: 'Year 2000',
        type: 'bar',
        data: [814, 841, 3714, 726]
      },
      {
        name: 'Year 2021',
        type: 'bar',
        data: [1393, 1031, 4695, 745]
      }
    ]
  };
  categories: any[] = [];

  seriesData: Highcharts.SeriesOptionsType[] = [

  ];









  @ViewChild('navMenu') navMenu!: ElementRef;
  @ViewChild('mobileToggle') mobileToggle!: ElementRef;
  @ViewChild('backToTop') backToTop!: ElementRef;


  onScroll(): void {
    // Back to top visibility
    if (this.backToTop) {
      if (window.scrollY > 500) {
        this.backToTop.nativeElement.classList.add('visible');
      } else {
        this.backToTop.nativeElement.classList.remove('visible');
      }
    }

    // Header scroll effect
    const header = document.querySelector('.main-header') as HTMLElement;
    if (header) {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
  }

  goToSlide(index: number): void {
    this.slides.forEach(slide => slide.classList.remove('active'));
    this.indicators.forEach(ind => ind.classList.remove('active'));

    this.currentSlide = index;
    if (this.currentSlide >= this.slides.length) this.currentSlide = 0;
    if (this.currentSlide < 0) this.currentSlide = this.slides.length - 1;

    this.slides[this.currentSlide].classList.add('active');
    this.indicators[this.currentSlide].classList.add('active');

    if (this.progressBar) {
      this.renderer.setStyle(this.progressBar.nativeElement, 'animation', 'none');
      this.progressBar.nativeElement.offsetHeight; // trigger reflow
      this.renderer.setStyle(this.progressBar.nativeElement, 'animation', `progress ${this.slideDuration}ms linear`);
    }
  }

  nextSlide(): void { this.goToSlide(this.currentSlide + 1); }
  prevSlide(): void { this.goToSlide(this.currentSlide - 1); }

  startSlider(): void {
    this.slideInterval = setInterval(() => this.nextSlide(), this.slideDuration);
    if (this.progressBar) {
      this.renderer.setStyle(this.progressBar.nativeElement, 'animation', `progress ${this.slideDuration}ms linear`);
    }
  }

  resetSlider(): void {
    clearInterval(this.slideInterval);
    this.startSlider();
  }

  onPrevClick(): void {
    this.prevSlide();
    this.resetSlider();
  }

  onNextClick(): void {
    this.nextSlide();
    this.resetSlider();
  }

  onIndicatorClick(index: number): void {
    this.goToSlide(index);
    this.resetSlider();
  }
}


